import MediaCarousel from '../../../shop/MediaCarousel';
import { CarouselElement } from '../../../types/shop';

const videoIDs = ['RzR8gZ_sBjQ', 'PnlJ-KRdxm8', 'SxdB0o1k65Q', 'KFNn-DuvTEU'];

const decoratedVideos: CarouselElement[] = videoIDs.map((videoHandler, index) => {
  return {
    id: index,
    indexPosition: index,
    isVideo: true,
    videoURL: `https://www.youtube.com/shorts/${videoHandler}`,
    src: `https://img.youtube.com/vi/${videoHandler}/maxresdefault.jpg`,
    alt: `how to collect sample step ${index}`,
  };
});

export default function HowToCollectCarouselWithVideos() {
  return (
    <MediaCarousel elements={decoratedVideos} videoConfiguration={{ videoHeight: '360px', containerWidth: '360px' }} />
  );
}
